export type PixelBootstrapErrorCode =
  | 'NOT_BROWSER'
  | 'CONSENT_DENIED'
  | 'INIT_FAILED';

export class PixelBootstrapError extends Error {
  readonly code: PixelBootstrapErrorCode;
  readonly cause?: unknown;

  constructor(message: string, code: PixelBootstrapErrorCode, cause?: unknown) {
    super(message);
    this.name = 'PixelBootstrapError';
    this.code = code;
    if (cause !== undefined) {
      this.cause = cause;
    }
  }
}
